import React from 'react';
import './FullPageLoader.css';

export default function FullPageLoader({ message = 'Loading…' }) {
  const src = `${process.env.PUBLIC_URL || ''}/loading.webm`;

  return (
    <div className="mb-loader-overlay" role="status" aria-live="polite" aria-busy="true">
      <div className="mb-loader-card">
        <video
          className="mb-loader-video"
          src={src}
          autoPlay
          muted
          playsInline
          loop
        />
        <div className="mb-loader-text">{message}</div>
      </div>
    </div>
  );
}
